module.exports = __webpack_public_path__ + "img/gold_symbol_2.dc4c43d5.png";